import React from 'react';
import { FlagOutlined } from '@ant-design/icons';

import { QuestionListItem, QuestionItem } from '../types';

const testList = [
  {
    id: 1,
    value: '单选题(共10题，合计50.0分)',
    list: [
      { id: 1, isChecked: true },
      { id: 2, isChecked: false },
      { id: 3, isChecked: false },
      { id: 4, isChecked: true },
      { id: 5, isChecked: false },
      { id: 6, isChecked: false },
      { id: 7, isChecked: true },
      { id: 8, isChecked: false },
      { id: 9, isChecked: false },
      { id: 10, isChecked: true }
    ]
  },
  {
    id: 2,
    value: '多选题(共10题，合计20.0分), 漏选不得分',
    list: [
      { id: 1, isChecked: true },
      { id: 2, isChecked: false },
      { id: 3, isChecked: false }
    ]
  },
  {
    id: 3,
    value: '判断题(共1题，合计10.0分)',
    list: [
      { id: 1, isChecked: true },
    ]
  },
  {
    id: 4,
    value: '填空题(共1题，合计10.0分)',
    list: [
      { id: 1, isChecked: true },
    ]
  },
  {
    id: 5,
    value: '问答题(共1题，合计10.0分)',
    list: [
      { id: 1, isChecked: true },
    ]
  }
]

interface IProps {
  questionList: QuestionListItem[];
}

function AnswerList({ questionList }: IProps) {

  function onClickA(e: any, id: string) {
    e.preventDefault();
    const ele: any = document.getElementById(id);
    ele.scrollIntoView();
  }

  
  function computedCount(data: QuestionItem[]): number {
    let totalCount = 0;
    data.map(item => {
      totalCount += item.grade;
    })
    return totalCount;
  }

  return (
    <div className="content-left">
      <div className="content-left-top">
        <div className="title">
          <div className="line"></div>
          <div className="text">答题卡</div>
        </div>
        <ul className="ul-list">
          {
            questionList.map((test, index) => {
              return (
                <li className="ul-list-li" key={index}>
                  <div className="title">{test.title}(共{test.questions.length}题，合计{computedCount(test.questions).toFixed(1)}分)</div>
                  <ul className="ul-numbers">
                    {
                      test.questions.map((ques, index2) => {
                        return (
                          <li className="ul-numbers-li" key={index2}>
                            <a href={`#${ques.id}`} onClick={(e) => onClickA(e, ques.id)}>
                              <div className={`number ${ques.myAnswer ? 'active' : ''}`}>{index2 + 1}</div>
                              <div>
                                {ques.flag === 1 && <FlagOutlined style={{color: '#1DA57A'}} />}
                              </div>
                            </a>
                          </li>
                        )
                      })
                    }
                  </ul>
                </li>
              )
            })
          }
          {/* <li className="ul-list-li">
            <div className="title">单选题(共10题，合计50.0分)</div>
            <ul className="ul-numbers">
              <li className="ul-numbers-li">
                <div className="number">1</div>
                <div><FlagOutlined /></div>
              </li>
            </ul>
          </li> */}
        </ul>
      </div>
      <div className="content-left-bot">
        <div className="status">
          <div className="answered">
            <div className="icon"></div>
            <div className="value">已答</div>
          </div>
          <div className="answered">
            <div className="icon gray"></div>
            <div className="value">未答</div>
          </div>
          <div className="answered">
            <div className="qi"><FlagOutlined /></div>
            <div className="value">标记</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AnswerList;
